import React, { useState, useCallback, useEffect } from "react";
import { InfoIcon } from "lucide-react";

const AssessmentPreferences = (companyId) => {
  return (
    <div>
      <div className="container mx-auto p-4 lg:p-8">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-3xl font-bold text-indigo-800">
            Edit Company Assessment Preferences
          </h2>
        </div>

        <div className="mb-8">
          <div className="bg-white shadow sm:rounded-lg border border-gray-100 overflow-hidden transform transition-all duration-300 hover:shadow-md">
            <div className="px-4 py-5 sm:p-6">
              <div className="sm:flex sm:items-start sm:justify-between">
                <div>
                  <div className="mt-2 w-full flex items-center gap-2 text-sm text-gray-500">
                    <InfoIcon className="w-4 h-4 text-sm"/>
                    <p>
                      Company preferences establish default settings for all
                      assessments. Profile-specific settings will override these
                      preferences.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AssessmentPreferences;
